import UserSummary from "@/models/Settings/Users/UserSummary";
import UserRole from "@/models/Settings/Users/UserRole";
import Amount from "@/models/Shared/Amount";

export default class UserDetails extends UserSummary {
    paymentOrderApprovalLimit: Amount = new Amount();
    paymentOrderApprovalNotificationLowerLimit: Amount = new Amount();
    roles: UserRole[];
    globalAdmin: boolean = false;
}